import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ToggleButton from '@mui/material/ToggleButton';
import { get } from 'global/lib/lodash';
import { setView } from 'redux/actions/view';
import { useEdit } from '../../hooks/useEdit';
import { useFilter } from '../../hooks/useFilter';
import { useShowChanges } from '../../hooks/useShowChanges';
import { userHasPermissions } from 'redux/actions/userLogin';
import { useUser } from '../../hooks/useUser';
import { useScreen } from 'global/styles';
import { FilterBar, FilterButton } from 'global/components/AssessmentFilters';
import { FilterRatingGroup } from 'global/components/AssessmentFilters/styles';

export const SelectLangEditBar = (props) => {
  const showTranslations = get(props, 'showTranslations', false);
  const hasPerm = userHasPermissions(['createLibrary']);
  const canEdit = get(props, 'canEdit', hasPerm);
  const canShowChanges = get(props, 'canShowChanges');
  const onPrintSelect = get(props, 'onPrintSelect');
  const selectionMode = get(props, 'selectionMode', false);
  const uhook = useUser();
  const [showLocation, setShowLocation] = useState(get(props, 'showLocation', true));
  const { isMobile } = useScreen();

  const { editOn, toggleEdit } = useEdit();
  const { showChangesOn, toggleShowChanges } = useShowChanges();
  const { filter, changeFilter } = useFilter('library.editions');

  const lang = useSelector((state) => get(state, 'view.lang'));
  const dispatch = useDispatch();

  const handleChange = (e, val) => {
    if (val) {
      dispatch(setView({ lang: { ...lang, id: val } }));
    }
  };

  const locationOn = !!get(filter, 'useLocation', false);

  const changeLocation = () => {
    changeFilter('useLocation', !locationOn);
  };

  const userIsBuilderTier = get(uhook, 'siteContextRealmTier') === 'builder';

  useEffect(() => {
    const tier = get(uhook, 'siteContextRealmTier');

    if (tier) {
      if (tier === 'builder') {
        changeFilter('useLocation', false);
      } else if (tier === 'division') {
        changeFilter('useLocation', true);
      }
    }
  }, [uhook.siteContextRealmTier]);

  useEffect(() => {
    if (props.edition) {
      const edtier = get(props, 'edition.realm.tier');
      const hasdocs = get(props, 'edition.config.docs');
      if (edtier === 'division' || !hasdocs) {
        setShowLocation(false);
      }
    }
  }, [props.edition]);

  const show = showTranslations || canEdit || showLocation || canShowChanges || !!onPrintSelect;

  if (!show) {
    return null;
  }

  const editLabel = isMobile ? 'Edit' : 'Edit Tools';

  return (
    <FilterBar>
      {showTranslations && (
        <FilterRatingGroup exclusive size="small" color="primary" value={get(lang, 'id')} onChange={handleChange} aria-label="Available In">
          {get(lang, 'avail', []).map((a) => (
            <ToggleButton key={a.id} value={a.id}>
              {a.title}
            </ToggleButton>
          ))}
        </FilterRatingGroup>
      )}

      {canEdit && (
        <FilterButton active={editOn} onClick={toggleEdit} aria-label={editLabel}>
          {editLabel}
        </FilterButton>
      )}

      {canShowChanges && (
        <FilterButton active={showChangesOn} onClick={() => toggleShowChanges()} aria-label="Show Changes">
          Show Changes
        </FilterButton>
      )}

      {showLocation && (
        <FilterButton active={locationOn} disabled={userIsBuilderTier} onClick={changeLocation} aria-label="Use Location">
          Use Location
        </FilterButton>
      )}

      {onPrintSelect && <FilterButton active={selectionMode} onClick={onPrintSelect} icon="print" aria-label="Select standards to print" />}
    </FilterBar>
  );
};
